module.exports = (target, newClass) => {
    let $target = [];
    const className = newClass || 'is-active';

    // check if var target is a selector or DOM element.
    if (target.nodeType) {
        $target.push(target);
    } else {
        $target = document.querySelectorAll(target);
    }

    $target.forEach($el => {
        $el.classList.toggle(className);
    });
}